module.exports = __webpack_public_path__ + "static/img/news4.85924e74.png";